import React, { useEffect } from 'react'
import MUIDataTable from "mui-datatables";
import EditIcon from '@material-ui/icons/Edit';
import { createMuiTheme, MuiThemeProvider, Switch, TableCell, Typography, withStyles } from "@material-ui/core";
import AddPasien from '../MasterData/addPasien';
import AddDocter from '../MasterData/addDocter';
import DetailDocter from '../MasterData/detailDocter';
import FilterDocter from '../MasterData/filterDokter';
import { getDocter } from '../../store/actions/dokterAction';
import { useDispatch, useSelector } from 'react-redux';
import editIcon from '../../assets/1@3x.png';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions()

const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 20,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});


export default function PerubahanReservasi(props) {
    const dokter = useSelector((store) => store.dokterReducer.dokter);
    const [visibleCreate, setVisibleCreate] = React.useState(false);
    const [visibleFilter, setVisibleFilter] = React.useState(false);
    const [visibleDetail, setVisibleDetail] = React.useState(false);
    const [detail, setDetail] = React.useState([])
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getDocter())
    }, [])
   
    const columns = [
        {
            name: "kodeDokter",
            label: "Kode Dokter"
        },
        {
            name: "namaDokter",
            label: "Nama Dokter"
        },
        {
            name: "spesialis",
            label: "Spesialis/ Poliklinik"
        },
        {
            name: "namaPasien",
            label: "Nama Pasien"
        },
        {
            name: "hari",
            label: "Hari"
        }, 
        {
            name: "waktu",
            label: "Waktu"
        },
        {
            name: "antrian",
            label: "Antrian"
        }, 
        {
            name: "status",
            label: "Status"
        },
        {
            name: "Aksi",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <button
                                onClick={() => handleSeeDetail(tableMeta)}
                                style={{
                                    backgroundColor: "transparent",
                                    fontSize: 20,
                                    outline: 'none',
                                    borderColor: 'transparent',
                                    marginRight: 20
                                }}>
                                <img src={editIcon} style={{width: 30, height: 30}} />
                            </button>
                        </div>
                    )
                }
            }
        }];

    const onOpen = () => {
        setVisibleCreate(true);
    };

    const onClose = () => {
        setVisibleCreate(false);
        setVisibleFilter(false);
        setVisibleDetail(false);
    };

    const handleSeeDetail = ({ rowData }) => {
        setDetail(rowData)
        setVisibleDetail(true);
    };

    return (
        <div style={{ paddingTop: 20, }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: 1 }}>
                {/* <div style={{ display: 'flex' }}>
                    <div onClick={(() => setVisibleFilter(true))} style={{ height: 32, width: 40, backgroundColor: 'white', borderRadius: 20, marginRight: 10, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                        <img
                            style={{ margin: 'auto', width: 20, marginLeft: 10, marginTop: 5 }} src="https://img.icons8.com/android/24/000000/menu.png" />
                    </div>
                    <div style={{ height: 32, width: 170, backgroundColor: 'white', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999' }} />
                </div> */}
            </div>
            {/* <div style={{ marginTop: 20, boxShadow: '5px 2px 10px 0 #999999', borderRadius: 30 }}> */}
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={dokter}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>
            {/* </div> */}

            {visibleCreate ?
                <AddDocter
                    onClose={onClose}
                /> : null}
            {visibleDetail ?
                <DetailDocter
                    onClose={onClose} 
                    detail={detail}
                    />
                : null}

            {visibleFilter ?
                <FilterDocter
                    onClose={onClose} /> : null}
        </div>
    )
}